var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "fixed-top", attrs: { id: "header" } }, [
    _c("nav", { staticClass: "navbar justify-content-between" }, [
      _c("div", { staticClass: "left-container" }, [
        _c("h1", { staticClass: "logo", on: { mouseenter: _vm.navClose } }, [
          _c("a", { attrs: { href: "/" } }, [_vm._v("GCRM")])
        ]),
        _vm._v(" "),
        _vm.userInfo && _vm.highestRole
          ? _c(
              "ul",
              { staticClass: "navbar-nav" },
              [
                _vm._l(_vm.getAuthRootMenu(), function(authI18) {
                  return _c(
                    "li",
                    { key: authI18.authRootCode, staticClass: "nav-item" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "menu-1depth",
                          class: {
                            on:
                              authI18.authRootCode ===
                                _vm.selectedAuthRootCode &&
                              !_vm.selectedMenu.menuId
                          },
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.authMenuClick(authI18.authRootCode)
                            },
                            mouseover: function($event) {
                              return _vm.authMenuClick(authI18.authRootCode)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t(authI18.messageKey)) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        authI18.authRootCode === _vm.selectedAuthRootCode &&
                        !_vm.selectedMenu.menuId
                          ? _c(
                              "ul",
                              { staticClass: "sub-nav" },
                              _vm._l(_vm.getAuthSubMenu(authI18, 1), function(
                                item,
                                index
                              ) {
                                return _c("span", { key: item.regionCode }, [
                                  _c(
                                    "li",
                                    { staticClass: "sub-item" },
                                    [
                                      _vm.getAuthSubMenu(authI18, 2).length
                                        ? [
                                            _c(
                                              "a",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-toggle",
                                                    rawName: "v-b-toggle",
                                                    value:
                                                      "subaccordion-" + index,
                                                    expression:
                                                      "`subaccordion-${index}`"
                                                  }
                                                ],
                                                staticClass:
                                                  "menu-2depth isSub collapsed",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.getLabel({
                                                        labelJson:
                                                          item.platformCodeLabelJson
                                                      })
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-collapse",
                                              {
                                                staticClass: "sub",
                                                attrs: {
                                                  id: "subaccordion-" + index,
                                                  accordion: "my-accordion"
                                                }
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  { staticClass: "sub-list" },
                                                  _vm._l(
                                                    _vm.getAuthSubMenu(item, 2),
                                                    function(subItem) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key:
                                                            subItem.regionCode
                                                        },
                                                        [
                                                          _c(
                                                            "a",
                                                            {
                                                              attrs: {
                                                                href:
                                                                  "javascript:void(0)"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.setExternalUrl(
                                                                    subItem
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.getLabel(
                                                                      {
                                                                        labelJson:
                                                                          subItem.regionCodeLabelJson
                                                                      }
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "a",
                                              {
                                                staticClass: "menu-2depth",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setExternalUrl(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.getLabel({
                                                        labelJson:
                                                          item.platformCodeLabelJson
                                                      })
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ])
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.rootMenus, function(menu, index) {
                  return _c(
                    "li",
                    {
                      key: menu.menuId,
                      staticClass: "nav-item",
                      attrs: { index: menu.menuId }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "menu-1depth",
                          class: {
                            on:
                              menu.menuId === _vm.selectedMenu.menuId &&
                              _vm.selectedMenu.isNavOpen
                          },
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.navClick(menu, index)
                            },
                            mouseover: function($event) {
                              return _vm.navClick(menu, index)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getLabel(menu)) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("transition", { attrs: { name: "fade" } }, [
                        menu.menuId === _vm.selectedMenu.menuId &&
                        _vm.selectedMenu.isNavOpen
                          ? _c(
                              "ul",
                              { staticClass: "sub-nav" },
                              _vm._l(_vm.getSubmenu(menu.menuId), function(
                                submenu,
                                subIndex
                              ) {
                                return _c(
                                  "li",
                                  {
                                    key: submenu.menuId,
                                    staticClass: "sub-item",
                                    class: {
                                      "cstm-hide":
                                        submenu.menuId === "AYLObAaaAv0DAd_9" &&
                                        _vm.userInfo.compCode === "PC2"
                                    },
                                    attrs: { index: submenu.menuId }
                                  },
                                  [
                                    _vm.getSubmenu(submenu.menuId).length > 0
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              directives: [
                                                {
                                                  name: "b-toggle",
                                                  rawName: "v-b-toggle",
                                                  value:
                                                    "subaccordion-" + subIndex,
                                                  expression:
                                                    "'subaccordion-' + subIndex"
                                                }
                                              ],
                                              staticClass:
                                                "menu-2depth isSub collapsed",
                                              attrs: { href: "javascript:" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.getLabel(submenu)
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-collapse",
                                            {
                                              staticClass: "sub",
                                              attrs: {
                                                id: "subaccordion-" + subIndex,
                                                accordion: "my-accordion"
                                              }
                                            },
                                            [
                                              _c(
                                                "ul",
                                                { staticClass: "sub-list" },
                                                _vm._l(
                                                  _vm.getSubmenu(
                                                    submenu.menuId
                                                  ),
                                                  function(item) {
                                                    return _c(
                                                      "li",
                                                      { key: item.menuId },
                                                      [
                                                        _vm.checkMenuByCountryCode3Level(
                                                          _vm.getLabel(item),
                                                          _vm.myCountryCode
                                                        )
                                                          ? _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    "javascript:"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return _vm.moveMenu(
                                                                      item.menuUrl,
                                                                      item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                          " +
                                                                    _vm._s(
                                                                      _vm.getLabel(
                                                                        item
                                                                      )
                                                                    ) +
                                                                    "\n                        "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          )
                                        ]
                                      : [
                                          submenu.defaultPage &&
                                          _vm.checkMenuByCountryCode2Level(
                                            submenu.label,
                                            _vm.myCountryCode
                                          )
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "menu-2depth",
                                                  attrs: {
                                                    href: "javascript:"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.moveMenu(
                                                        submenu.defaultPage
                                                          .pagePath,
                                                        submenu
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getLabel(submenu)
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              "line-height": "72px",
              "padding-left": "20px",
              cursor: "default"
            },
            on: { mouseenter: _vm.navClose }
          },
          [_vm._v(" ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-container", on: { mouseenter: _vm.navClose } },
        [
          _vm.userInfo && _vm.highestRole
            ? _c(
                "div",
                { staticClass: "myinfo" },
                [
                  !_vm.isRewardsUser
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-myinfo",
                          attrs: { type: "button" },
                          on: { click: _vm.onInfoClick }
                        },
                        [_vm._v(_vm._s(_vm.userInfo.userName))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isRewardsUser
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-myinfo",
                          staticStyle: {
                            width: "100px",
                            "white-space": "nowrap",
                            overflow: "hidden",
                            "text-overflow": "ellipsis"
                          },
                          attrs: { type: "button" },
                          on: { click: _vm.onInfoClick }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.userInfo.userName) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "slide" } }, [
                    _vm.isMyInfoActive
                      ? _c("div", { staticClass: "myinfo-dropdown" }, [
                          _c("div", { staticClass: "in" }, [
                            _c("div", { staticClass: "info-hd" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getLabel({
                                      labelJson: _vm.roleCodeLabelJson
                                    })
                                  ) +
                                  "\n              "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-cnt" }, [
                              _c(
                                "ul",
                                { staticClass: "ul" },
                                _vm._l(_vm.userAuthListGroupByRegion, function(
                                  item,
                                  index
                                ) {
                                  return _c("span", { key: item.regionCode }, [
                                    !index ||
                                    item.platformCode !==
                                      _vm.userAuthListGroupByRegion[index - 1]
                                        .platformCode
                                      ? _c(
                                          "li",
                                          [
                                            _c(
                                              "button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-toggle",
                                                    rawName: "v-b-toggle",
                                                    value: "accordion-" + index,
                                                    expression:
                                                      "'accordion-' + index"
                                                  }
                                                ],
                                                staticClass: "i-menu collapsed",
                                                attrs: { type: "button" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.getLabel({
                                                        labelJson:
                                                          item.platformCodeLabelJson
                                                      })
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-collapse",
                                              {
                                                staticClass: "sub",
                                                attrs: {
                                                  id: "accordion-" + index,
                                                  accordion: "my-accordion"
                                                }
                                              },
                                              [
                                                _c(
                                                  "ul",
                                                  _vm._l(
                                                    _vm.userAuthListGroupByRegion,
                                                    function(subItem) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key:
                                                            subItem.regionCode
                                                        },
                                                        [
                                                          item.platformCode ===
                                                          subItem.platformCode
                                                            ? _c("li", [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      _vm.getLabel(
                                                                        {
                                                                          labelJson:
                                                                            subItem.regionCodeLabelJson
                                                                        }
                                                                      )
                                                                    ) +
                                                                    "\n                            "
                                                                )
                                                              ])
                                                            : _vm._e()
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-btm" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary btn-xs",
                                  attrs: { type: "button" },
                                  on: { click: _vm.logoutConfirmFn }
                                },
                                [_vm._v("Logout")]
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isRewardsUser
            ? _c(
                "div",
                { staticClass: "global" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn_global",
                      attrs: { type: "button" },
                      on: { click: _vm.onGlobalClick }
                    },
                    [
                      _c(
                        "label",
                        {
                          attrs: {
                            tooltip:
                              _vm.myCountryName +
                              "(" +
                              _vm.myCountryOffset +
                              ")",
                            "tooltip-position": "bottom"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.myCountryName) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("transition", { attrs: { name: "slide" } }, [
                    _vm.isMyGlobalActive
                      ? _c("div", { staticClass: "global-dropdown" }, [
                          _c("div", { staticClass: "in" }, [
                            _c("div", { staticClass: "info-cnt" }, [
                              _c(
                                "ul",
                                { staticClass: "ul" },
                                _vm._l(
                                  _vm.userCountryListGroupByRegion,
                                  function(item, index) {
                                    return _c(
                                      "span",
                                      { key: item.countryCode },
                                      [
                                        !index ||
                                        item.countryRegion !==
                                          _vm.userCountryListGroupByRegion[
                                            index - 1
                                          ].countryRegion
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-toggle",
                                                        rawName: "v-b-toggle",
                                                        value:
                                                          "accordion-" + index,
                                                        expression:
                                                          "'accordion-' + index"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "i-menu collapsed",
                                                    attrs: { type: "button" }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          item.countryRegion
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "b-collapse",
                                                  {
                                                    staticClass: "sub",
                                                    attrs: {
                                                      id: "accordion-" + index,
                                                      accordion: "my-accordion"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "ul",
                                                      _vm._l(
                                                        _vm.userCountryListGroupByRegion,
                                                        function(subItem) {
                                                          return _c(
                                                            "span",
                                                            {
                                                              key:
                                                                subItem.countryCode
                                                            },
                                                            [
                                                              item.countryRegion ===
                                                              subItem.countryRegion
                                                                ? _c(
                                                                    "li",
                                                                    {
                                                                      on: {
                                                                        click: function(
                                                                          $event
                                                                        ) {
                                                                          return _vm.onChangeGlobal(
                                                                            subItem.countryCode,
                                                                            subItem.countryOffset
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            subItem.countryName
                                                                          ) +
                                                                          " (" +
                                                                          _vm._s(
                                                                            subItem.countryOffset
                                                                          ) +
                                                                          ")\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ])
                          ])
                        ])
                      : _vm._e()
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "lang" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedLocale,
                    expression: "selectedLocale"
                  }
                ],
                staticClass: "form-control",
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedLocale = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.changeLocale
                  ]
                }
              },
              _vm._l(_vm.availableLocales, function(locale) {
                return _c(
                  "option",
                  {
                    key: locale,
                    class: { selected: locale === _vm.$i18n.locale },
                    attrs: { "data-locale": locale },
                    domProps: { value: locale }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getLocaleLabel(locale)) +
                        "\n          "
                    )
                  ]
                )
              }),
              0
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        ref: "keyParamFormHeader",
        attrs: { name: "keyParamFormHeader", method: "post", target: "newWin" }
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.key_param,
              expression: "key_param"
            }
          ],
          attrs: { type: "hidden", name: "key_param" },
          domProps: { value: _vm.key_param },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.key_param = $event.target.value
            }
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d1249c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d1249c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/GcrmHeader.vue
// module id = null
// module chunks = 